import React, { useEffect, useState } from "react";
import { Button, Chip, Box, Badge } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import CrossIcon from "../assets/images/cross.svg";
import FilterIcon from "../assets/images/filter.svg";
import { fetchOffersByFilter } from "../redux/slice/offers/offers";

const Filters = ({ selectedFilters, setSelectedFilters }) => {
  // const [selectedFilters, setSelectedFilters] = useState([]);
  const { offersFilterData } = useSelector((state) => state.offers);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchOffersByFilter());
  }, []);
  return (
    <Box display="flex" gap={1} alignItems="center">
      {/* Filter Button with Badge */}
      <Button
        variant="contained"
        color="primary"
        endIcon={<img src={FilterIcon} alt="filter icon" />}
        sx={{
          backgroundColor: "black",
          color: "white",
        }}
        className="filter-btn"
      >
        {selectedFilters?.length !== 0 && (
          <span className="filter-count">{selectedFilters.length}</span>
        )}
        Filter
      </Button>

      {/* Categories as Buttons */}
      {offersFilterData?.map((category) => (
        <Button
          key={category?.attributes?.Filter}
          variant="outlined"
          sx={{
            borderColor: "#1D1D1B1F",
            backgroundColor: `${
              selectedFilters.includes(category?.attributes?.Filter)
                ? "#ffffff"
                : "f7f3eb"
            }`,
            color: "black",
            fontWeight: `${
              selectedFilters.includes(category?.attributes?.Filter)
                ? "700"
                : "300"
            }`,
          }}
          className="filter-btn"
          onClick={() => {
            if (!selectedFilters.includes(category?.attributes?.Filter)) {
              setSelectedFilters((prev) => {
                if (prev.includes(category?.attributes?.Filter)) return prev;
                else return [...prev, category?.attributes?.Filter];
              });
            }
          }}
        >
          {category?.attributes?.Filter}
          {selectedFilters.includes(category?.attributes?.Filter) && (
            <img
              src={CrossIcon}
              alt="cross icon"
              onClick={() =>
                setSelectedFilters((prev) => {
                  const remFilters = prev.filter(
                    (val) => val !== category?.attributes?.Filter
                  );

                  return remFilters;
                })
              }
            />
          )}
        </Button>
      ))}
    </Box>
  );
};

export default Filters;
